var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2 description"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "+_vm._s(_vm.usersCount ? `Has ${_vm.usersCount} user${_vm.isPlural ? "s" : ""} on Google Chrome.` : "")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }